import { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import { ArrowLeft } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ArticleDetailPage() {
  const { id } = useParams();
  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`${API}/news/${id}`)
      .then((r) => setArticle(r.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [id]);

  if (loading) {
    return (
      <div className="pt-20 min-h-screen flex items-center justify-center">
        <div className="animate-pulse text-[#777]">Chargement...</div>
      </div>
    );
  }

  if (!article) {
    return (
      <div className="pt-20 min-h-screen flex flex-col items-center justify-center gap-4">
        <p className="font-heading text-2xl text-[#333]">Article non trouvé</p>
        <Link to="/actualites" className="text-[#699ab6] text-sm underline">
          Retour aux articles
        </Link>
      </div>
    );
  }

  return (
    <div data-testid="article-detail-page" className="pt-20">
      {/* Hero image */}
      <div className="w-full aspect-[21/7] bg-[#F5F5F5] overflow-hidden">
        <img
          src={article.image}
          alt={article.title}
          className="w-full h-full object-cover"
        />
      </div>

      <div className="max-w-3xl mx-auto px-6 lg:px-12 py-12 lg:py-16">
        <Link
          to="/actualites"
          data-testid="back-to-articles"
          className="inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.15em] font-medium text-[#777] hover:text-[#699ab6] transition-colors mb-8"
        >
          <ArrowLeft className="w-4 h-4" />
          Retour aux articles
        </Link>

        <p className="text-[10px] text-[#999] uppercase tracking-wider mb-3">
          {new Date(article.created_at).toLocaleDateString("fr-CH", {
            day: "numeric",
            month: "long",
            year: "numeric",
          })}
        </p>

        <h1
          data-testid="article-title"
          className="font-heading text-3xl lg:text-4xl font-medium text-[#333] tracking-tight mb-3"
        >
          {article.title}
        </h1>

        {article.subtitle && (
          <p className="font-accent italic text-[#699ab6] text-lg mb-8">
            {article.subtitle}
          </p>
        )}

        <div className="w-12 h-0.5 bg-[#699ab6] mb-8" />

        <div data-testid="article-content" className="prose-custom">
          {article.content.split("\n\n").map((paragraph, i) => (
            <p
              key={i}
              className="text-[#555] text-base leading-relaxed font-light mb-5"
            >
              {paragraph}
            </p>
          ))}
        </div>
      </div>
    </div>
  );
}
